

var React = require('react');
var FontAwesome = require('react-fontawesome');

const Loading = (props) => {
  return(
    <div
      style={{
        height: '400px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <FontAwesome
        name="circle-o-notch"
        size="4x"
        spin={true}
      />
    </div>
  )
}


export default Loading;



// WEBPACK FOOTER //
// ./src/comp/Loading.js